import React from 'react'
import cn from 'classnames'
import { humanFileSize } from 'util/strings'
import { fileClass } from 'util/mime'
import styles from './styles.css'

const Attachment = ({
  attachment,
  isSingle,
  isUploading,
  forNote,
  onDeleteClick,
  forDraft,
}) => {
  return (
    <div
      className={cn(styles.attachment, {
        [styles['attachment-uploading']]: isUploading,
        [styles['attachment-forNote']]: forNote,
      })}
    >
      {forDraft && (
        <div
          className={cn('Icon Icon-close', styles.deleteIcon)}
          onClick={() => onDeleteClick(attachment, forNote)}
        />
      )}
      <div className={styles.attachment_nameWithSize}>
        <div className={styles.attachment_name}>
          {isUploading && attachment.file_name}
          {!isUploading && (
            <a
              href={attachment.url}
              download={fileClass(attachment.file_type) !== 'text'}
            >
              {attachment.file_name}
            </a>
          )}
        </div>
        {isSingle &&
          !forNote && (
            <div
              className={cn('Icon Icon-attachment', styles.attachmentIcon)}
            />
          )}
        <div className={styles.attachment_size}>
          {isUploading
            ? `${attachment.progress}%`
            : humanFileSize(attachment.file_size)}
        </div>
        {isUploading && (
          <div className={styles.progressBar}>
            <div className={styles.progressBar_bg} />
            <div
              className={styles.progressBar_bar}
              style={{ transform: `scaleX(${attachment.progress / 100})` }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Attachment
